import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import Raphael from 'raphael';

class ScrollItem__ProjectHeader extends VScroll_Item {
  
  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);
    this._title = GetBy.class("title", this.item)[0];
    this._text = this._title.textContent;

    // Vaciar el h1 y crear contenedor para Raphael
    this._title.innerHTML = '';
    this._title.style.position = 'relative';
    this._svgContainer = document.createElement('div');
    this._svgContainer.style.width = '100%';
    this._svgContainer.style.height = '100%';
    this._title.appendChild(this._svgContainer);

    // Inicializar Raphaël
    this._paper = Raphael(this._svgContainer, '100%', '100%');
  }

  resize(w,h) {
      super.resize(w,h);

      const rect = this._title.getBoundingClientRect();
      const width = rect.width;
      const height = rect.height;

      // Ajustar tamaño de SVG
      this._paper.setSize(width, height);

      // Dibujar el texto con sombra interior
      this._drawText(width, height);
  }

  _drawText(width, height) {
    const paper = this._paper;

    // Limpiar todo
    paper.clear();

    // Crear el filtro emboss
    const svgNS = "http://www.w3.org/2000/svg";
    const filter = document.createElementNS(svgNS, "filter");
    filter.setAttribute("id", "emboss");
    filter.setAttribute("x", "0");
    filter.setAttribute("y", "0");
    filter.setAttribute("width", "200%");
    filter.setAttribute("height", "200%");
    filter.innerHTML = `
        <feGaussianBlur in="SourceAlpha" stdDeviation="1" result="blur"/>

        <feSpecularLighting in="blur" surfaceScale="2" specularConstant="1" specularExponent="20" lighting-color="#ffffff" result="light1">
            <fePointLight x="200" y="-100" z="10"/>
        </feSpecularLighting>

        <feSpecularLighting in="blur" surfaceScale="2" specularConstant="1" specularExponent="20" lighting-color="#ff0000" result="light2">
            <fePointLight x="200" y="300" z="10"/>
        </feSpecularLighting>

        <feMerge result="combinedLights">
          <feMergeNode in="light1"/>
          <feMergeNode in="light2"/>
      </feMerge>


        <feComposite in="combinedLights" in2="SourceAlpha" operator="in" result="lit"/>
        <feComposite in="SourceGraphic" in2="lit" operator="arithmetic" k1="0" k2="1" k3="1" k4="0"/>
    `;




    // Añadir filtro al SVG
    paper.canvas.appendChild(filter);

    // Crear el texto
    const text = paper.text(0, 30, "Filters are ice cold")
        .attr({
            "fill": "grey",
            
            "font-size": "74px",
            "text-anchor": "start"
        });

    // Aplicar el filtro al texto
    text.node.setAttribute("filter", "url(#emboss)");
    
  }

  loop() {
      
  }

  dispose() {
    super.dispose();
    if (this._paper) this._paper.remove();
  }
}

Scroll._registerClass('project-info-header', ScrollItem__ProjectHeader);
